export const STRINGS = {
    // Landing Page
    // LANDING_PAGE_HERO_COMPONENT_TITLE: "Land Your Dream Coding Job",
    // LANDING_PAGE_HERO_COMPONENT_TITLE: "Get Your First Software Engineering Job",
    LANDING_PAGE_HERO_COMPONENT_TITLE: "Turn Coding Skills Into Job Offers",
    // LANDING_PAGE_HERO_COMPONENT_SUBTITLE: "Your Coding Career, Simplified",
    // LANDING_PAGE_HERO_COMPONENT_SUBTITLE: "A step-by-step system that takes you from learning to code → getting hired",
    // LANDING_PAGE_HERO_COMPONENT_SUBTITLE: "Everything you need to turn coding skills into interviews",
    // LANDING_PAGE_HERO_COMPONENT_SUBTITLE: "A practical, step-by-step roadmap that shows new developers exactly how to go from “I can code” to “I’m getting interviews.”",
    // LANDING_PAGE_HERO_COMPONENT_SUBTITLE: "A clear path from learning to code to getting hired.",
    LANDING_PAGE_HERO_COMPONENT_SUBTITLE: "A step-by-step path to land your first developer job",
    // LANDING_PAGE_HERO_COMPONENT_SUBTITLE: "The quickest path to building your tech career",
    LANDING_PAGE_HERO_COMPONENT_CTA: "JOIN FOR FREE",

    EDUCATOR_PAGE_HERO_COMPONENT_TITLE: "Empower Your Students to Launch Tech Careers",
    EDUCATOR_PAGE_HERO_COMPONENT_SUBTITLE: "Give your students the practical skills, portfolio projects, and career support they need to land their first developer job.",
    EDUCATOR_PAGE_HERO_COMPONENT_CTA: "Get Beyond Code for My Students",
    EDUCATOR_PAGE_HEADER_CTA: "Beyond Code for Students",

    LANDING_NEVER_SHARE_INFO: "We’ll never share your info with anyone.",

    LANDING_PAGE_OVERVIEW_COMPONENT_TITLE: "Everything You Need to Succeed",
    EDUCATOR_PAGE_OVERVIEW_COMPONENT_TITLE: "Everything Your Students Needs to Succeed",

    // Account Page
    ACCOUNT_SETTINGS_TITLE: "Account Settings",
    ACCOUNT_MANAGE_CTA: "Manage Account",
    ACCOUNT_LOGOUT_CTA: "Logout",

    // Blog Page
    ALL_BLOG_POSTS: "All Blog Posts"
}